import { lazy } from 'react';
import { suspenseEnhancer } from 'hocs';

const Home = lazy(() => import('./modules/home/containers/Home'));
const Pools = lazy(() => import('./modules/home/containers/Pools'));
const QuestionAnswer = lazy(() =>
  import('./modules/home/containers/QuestionAnswer')
);
const Pool = lazy(() => import('./modules/pool/containers'));

const routes = [
  {
    path: '/',
    exact: true,
    public: true,
    component: suspenseEnhancer(Home, 'HOME_PAGE_TITLE'),
  },
  {
    path: '/pools',
    exact: true,
    public: true,
    component: suspenseEnhancer(Pools, 'HOME_POOLS_PAGE_TITLE'),
  },
  {
    path: '/question-answer',
    exact: true,
    public: true,
    component: suspenseEnhancer(QuestionAnswer, 'HOME_QA_PAGE_TITLE'),
  },
  {
    path: '/tech-support',
    exact: true,
    public: true,
    component: suspenseEnhancer(QuestionAnswer, 'HOME_QA_PAGE_TITLE'),
  },
  {
    path: '/pool/:slug',
    public: false,
    component: suspenseEnhancer(Pool, 'POOL_PAGE_TITLE'),
  },
];

export default routes;
